export default "__VITE_ASSET__CMLxWaqb__"